<div class="pageHeader">
  <h1>Accueil</h1>
</div>

<section class="section" id="partiesSection" hidden>
  <h2>Parties en cours</h2>
  <div id="partiesCarousel" class="carousel"></div>
</section>

<div id="recentSections"></div>
